import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

export { Wrapper };
